import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/Team.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import TeamSec from './TeamSec';

const HeroTeam = () => {
  return (
    <>
      <Helmet>
        <title>RCS Logistics Philippines - Management Team</title>
        <meta name="description" content="Meet the management team behind RCS Logistics Philippines, dedicated to delivering expert logistics, forwarding, and brokerage solutions." />
        <meta name="keywords" content="logistics, transportation, RCS Logistics, Philippines, management team, leadership, forwarding, brokerage, sea land service, freight forwarding, international shipping, supply chain management, cargo handling, customs brokerage, project cargo" />
        <meta property="og:url" content="https://rcslogisticsph.com/team" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="RCS Logistics Philippines - Management Team" />
        <meta property="twitter:description" content="Meet the management team behind RCS Logistics Philippines." />
        <meta property="twitter:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
      </Helmet>
      <section
        id="hero"
        className="team-hero-section d-flex align-items-center"
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <button
                disabled
                className="team-hero-button mb-4"
              >
                MEET OUR TEAM
              </button>
              <h1 className="text-white mb-4 team-hero-title">
                The People Behind RCS Logistics
              </h1>
              <p className="text-white-50 fs-5 team-hero-subtitle">
                Our management team brings decades of combined experience in global logistics,
                customs brokerage, and freight operations. Together, they guide RCS with the same
                hands-on, detail-driven approach we bring to every shipment.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Include the other sections */}
      <TeamSec />
    </>
  );
};

export default HeroTeam;
